import React, { useState } from 'react';
import { Box } from '@mui/material';
import { IProduct } from '../../../generated/graphql';
import CustomAppBar from '../../Common/Layout/CustomAppBar';
import PaperCard from '../../Common/Layout/PaperCard';
import TabPanel from '../../Common/Layout/TabPanel';
import ProductGeneralTab from './ProductGeneralTab';
import ProductEmailTab from './ProductEmailTab';

interface IProps {
  product: IProduct;
}

const ProductDetailsTabs: React.FunctionComponent<IProps> = ({ product }: IProps) => {
  const [value, setValue] = useState(0);

  return (
    <Box className="centralize" sx={{ width: '100%', paddingTop: '80px' }}>
      <PaperCard width="82%" additionalStyle={{ height: '680px' }}>
        <CustomAppBar
          type="third"
          value={value}
          handleChange={(_, newValue) => setValue(newValue)}
          tabProps={[
            {
              id: 'product-general-tab',
              title: 'General'
            },
            {
              id: 'product-email-tab',
              title: 'Email'
            }
          ]}
        />
        <TabPanel value={value} index={0}>
          <ProductGeneralTab product={product} />
        </TabPanel>
        <TabPanel value={value} index={1}>
          <ProductEmailTab product={product} />
        </TabPanel>
      </PaperCard>
    </Box>
  );
};

export default ProductDetailsTabs;
